import request from '../api';

// 获取App团队列表
export function getAppTeamList(data) {
  return request.post(`/app/team/getAppTeamList`, data);
}

//修改团队名称
export function updateAppTeamName(data) {
  return request.post(`/app/team/updateAppTeamName`, data);
}

/** 团队管理*/
// 获取App团队所有用户组
export function getAppTeamAllGroupList(teamId: any) {
  return request.post(`/app/team/getAppTeamAllGroupList/${teamId}`);
}

// 修改App团队用户组名称
export function updateAppTeamGroupName(data: any) {
  return request.post('/app/team/updateAppTeamGroupName', data);
}

// 新增App团队用户组
export function addAppTeamGroup(data: any) {
  return request.post('/app/team/addAppTeamGroup', data);
}

// 获取App团队成员分页列表
export function getAppTeamUserPage(data?: any) {
  const reqParam = { ...data, groupId: data.groupId === 'all' ? undefined : data.groupId };
  return request.post<any>('/app/team/getAppTeamUserPage', reqParam);
}

// 获取App团队用户组下的用户分页列表
export function getAppTeamUserPageByGroupId(data?: any) {
  const reqParam = { ...data, groupId: data.groupId === 'all' ? undefined : data.groupId };
  return request.post<any>('/app/team/getAppTeamUserPageByGroupId', reqParam);
}

// 将用户移除团队
export function removeAppTeamUserApi(data?: any) {
  return request.post<any>('/app/team/removeAppTeamUser', data);
}

export function deleteGroupApi(data?: any) {
  return request.post<any>('/app/team/deleteAppTeamGroup', data);
}

// 修改App团队用户所属用户组
export function updateAppTeamUserGroupApi(data) {
  return request.post('/app/team/updateAppTeamUserGroup', data);
}

// 获取App团队用户归属组
export function getAppTeamAllGroupCheckListApi(data) {
  return request.post('/app/team/getAppTeamAllGroupCheckList', data);
}

/** 团队资源 */
// 获取App团队所有成员和用户组
export function getAppTeamAllGroupUserListApi(data) {
  return request.post('/app/team/getAppTeamAllGroupUserList', data);
}

// 获取App用户形象资源分页列表
export function getAppTeamVirtualManPage(data) {
  return request.post('/app/team/getAppTeamVirtualManPage', data);
}

// 设置App团队资源权限
export function updateAppTeamResourceAuth(data) {
  return request.post('/app/team/updateAppTeamResourceAuth', data);
}

// 获取App团队邀请链接
export function getAppTeamInviteLink(data) {
  return request.post('/app/team/getAppTeamInviteLink', data);
}

// 接受App团队邀请
export function acceptAppTeamInvite(data) {
  return request.post('/app/team/acceptAppTeamInvite', data);
}

// 获取App团队和音色关系分页列表
export function getAppTeamTimbrePage(data) {
  return request.post('/app/teamTimbre/getAppTeamTimbrePage', data);
}
